import { connect } from 'react-redux'
import { GameMenuItems } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  const { language } = state.user
  return ({
    width,
    user,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameMenuItems)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameMenuItems.js